import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { X, Check, Info, AlertTriangle, AlertCircle } from 'react-feather';
import { Button } from '../button/Button.js';
import styles from './styles/Notifications.module.scss.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';

const Notification = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type = 'default',
    size = 'md',
    loading,
    disallowClose,
    title,
    icon,
    children,
    onClose,
    closeButtonProps,
    theme,
    style,
    contentRender,
    ...others
  } = props;
  const styles$1 = composeThemeFromProps(styles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const withIcon = icon || loading;
  const getIcon = type => {
    switch (type) {
      case 'error':
        return /*#__PURE__*/jsx(AlertCircle, {});
      case 'warning':
        return /*#__PURE__*/jsx(AlertTriangle, {});
      case 'notice':
        return /*#__PURE__*/jsx(Info, {});
      case 'success':
        return /*#__PURE__*/jsx(Check, {});
      default:
        return null;
    }
  };
  const finalIcon = icon || getIcon(type);
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles$1.notification, {
      [styles$1.has_icon]: withIcon,
      [styles$1.sm]: size === 'sm',
      [styles$1.md]: size === 'md',
      [styles$1.lg]: size === 'lg',
      [styles$1.notification_error]: type === 'error',
      [styles$1.notification_warning]: type === 'warning',
      [styles$1.notification_notice]: type === 'notice',
      [styles$1.notification_success]: type === 'success'
    }),
    role: "alert",
    ref: ref,
    style: style,
    ...omit(others, ['message']),
    children: typeof contentRender === 'function' ? contentRender : /*#__PURE__*/jsxs(Fragment, {
      children: [finalIcon && !loading && /*#__PURE__*/jsx("span", {
        className: clsx(styles$1.icon, {
          [styles$1.icon_error]: type === 'error',
          [styles$1.icon_warning]: type === 'warning',
          [styles$1.icon_notice]: type === 'notice',
          [styles$1.icon_success]: type === 'success'
        }),
        children: finalIcon
      }), loading && /*#__PURE__*/jsx("span", {
        className: styles$1.loader
      }), /*#__PURE__*/jsxs("div", {
        className: styles$1.body,
        children: [title && /*#__PURE__*/jsx("span", {
          className: styles$1.title,
          children: title
        }), /*#__PURE__*/jsx("div", {
          color: "dimmed",
          className: styles$1.description,
          children: children
        })]
      }), !disallowClose && /*#__PURE__*/jsx(Button, {
        theme: {
          root: styles$1.close
        },
        flat: true,
        noHover: true,
        shape: "circle",
        variant: "ghost",
        status: "secondary",
        onClick: onClose,
        "aria-label": "close",
        size: "xs",
        ...closeButtonProps,
        children: /*#__PURE__*/jsx(X, {})
      }, "clearIcon")]
    })
  });
});
Notification.displayName = 'Notification';

export { Notification };
